import PaginatedList from '@theme/paginated-list';
import { requestIdleCallback, startViewTransition } from '@theme/utilities';

const STORAGE_KEY = 'blog-posts-view';

/**
 * A custom element that renders a paginated blog posts list
 */
export default class BlogPostsList extends PaginatedList {
  /**
   * Bound to each view-toggle radio via `on:change="blog-posts-list/updateLayout"`.
   * Swaps between the tiered editorial grid and the flat thumbnail list (see
   * the `.blog-view--grid` / `.blog-view--list` wrappers in main-blog.liquid),
   * mirroring the collection page's grid-density toggle (results-list.js).
   *
   * @param {Event} event
   */
  updateLayout({ target }) {
    if (!(target instanceof HTMLInputElement)) return;

    this.#animateLayoutChange(target.value);
  }

  /** @param {string} value */
  #animateLayoutChange = async (value) => {
    const { grid } = this.refs;
    if (!grid) return;

    await startViewTransition(() => this.#setLayout(value), ['blog-posts-container']);

    requestIdleCallback(() => {
      sessionStorage.setItem(STORAGE_KEY, value);
    });
  };

  /** @param {string} value */
  #setLayout(value) {
    const { grid } = this.refs;
    if (!grid) return;
    grid.setAttribute('blog-view', value);
  }
}

if (!customElements.get('blog-posts-list')) {
  customElements.define('blog-posts-list', BlogPostsList);
}
